module.exports = __webpack_public_path__ + "img/icon_share_square.4fc1bdf0.svg";